import { useEffect, useState } from "react";

// STYLES
import * as Style from "./PowerUpModalStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./PowerUpModalModel";
import { useAppDispatch } from "hooks/reduxHooks";
import { powerUp } from "api/lockerApi";

// ASSETS

// REDUX

// COMPONENTS

const PowerUpModal = (props: IProps) => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  // CONSTANTS USING HOOKS
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [responseData, setResponseData] = useState<string>("")

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    handlePowerUp();
  }, [])

  // REQUEST API FUNCTIONS
  const handlePowerUp = () => {
    dispatch(powerUp())
      .unwrap()
      .then((response) => {
        if (response === "POWER-UP FINISH") {
          console.log("response", response)
          setResponseData(t("modal.powerUp.succesful"));
          setIsLoading(false);
        } else {
          console.log("response", response)
          setResponseData(`Error: ${response.message}`);
          setIsLoading(false);
        }
      })
      .catch(error => {
        setResponseData(`Error: ${error}`);
        setIsLoading(false);
        // Handle network error
      });
  }

  // HANDLERS FUNCTIONS

  return (
    <Style.ConfirmationModalContainer>
      <Style.HeaderContainer>{t("modal.powerUp.title")}</Style.HeaderContainer>
      {isLoading ?
        <Style.LodingSign /> :
        <Style.TextContainer>
          {responseData}
        </Style.TextContainer>}
    </Style.ConfirmationModalContainer>
  );
};

export default PowerUpModal;
